
import { Vue, Component, Prop, PropSync, Watch } from "vue-property-decorator";
import NavHeader from "@/components/semantics/KunMingHeader.vue";
import Footer from "@/components/semantics/Footer.vue";
@Component({
  name: 'StationKunMingDetail',
  components: {
    NavHeader,
    Footer
  },
})
export default class StationKunMingDetail extends Vue {

}
